import { atom } from 'jotai';

const userAtom = atom(null);

export default userAtom;
